import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    getRecipient,
    getIsRecipientLoading,
    getRecipientErrorMessage
} from './payoutRecipientEntity';
import {
    EmvioCard,
    EmvioLoadingSpinner,
    EmvioRow,
    EmvioTwoColumnItem
} from '@nexio/emvio-util-ui';
import {
    payoutRecipientShape
} from '../../utils/propTypes';
import {
    doesPropExistAndHasItChanged,
    payoutProviderMapper,
    prettifyMoney
} from '@nexio/emvio-util-app';
import { toastIfError } from '../../utils/toast';
import ErrorCard from '../ErrorCard/ErrorCard';
import mixpanel from '../../utils/mixpanel';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getPayoutRecipient } from './payoutRecipientActions';
import Payouts from '../Payouts/Payouts';
import './PayoutRecipient.scss';
import { prettifyDate } from '../../utils/string';

export class Recipient extends Component {
    static propTypes = {
        error: PropTypes.string,
        isRecipientLoading: PropTypes.bool,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        onGetRecipientById: PropTypes.func,
        onGoBack: PropTypes.func,
        recipient: payoutRecipientShape,
        onToggleModal: PropTypes.func,
        customAccess: PropTypes.any,
        payoutAccountMap: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetRecipientById(this.props.match.params.id);
        mixpanel.track('Recipient page mounted');
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'match.params.id')) {
            this.props.onGetRecipientById(this.props.match.params.id);
        }
    }

    renderPayoutSummary = () => {

        const totalPayoutsItems = [
            {
                label: 'Total Payouts',
                value: _.get(this.props.recipient, 'totalPayoutCount')
            }
        ];

        _.forEach(_.get(this.props.recipient, 'totalPayoutAmount'), (amount, currency) => {
            if (!_.find(totalPayoutsItems, { label: 'Total Payout Amount' })) {
                totalPayoutsItems.push({ label: 'Total Payout Amount', value: `${prettifyMoney(amount, currency)} ${currency}` });
            } else {
                totalPayoutsItems.push({ label: '', value: `${prettifyMoney(amount, currency)} ${currency}` });
            }
        });

        const latestPayoutItems = [];

        if (_.get(this.props.recipient, 'latestPayout')) {
            latestPayoutItems.push({
                label: 'Latest Payout Date',
                value: prettifyDate(_.get(this.props.recipient, 'latestPayout.date'))
            }, {
                label: 'Latest Payout Amount',
                value: prettifyMoney(_.get(this.props.recipient, 'latestPayout.amount'), _.get(this.props.recipient, 'latestPayout.currency'))
            });
        }

        return this.renderCard([...totalPayoutsItems, ...latestPayoutItems], 'Payout Summary');
    };

    renderDetails = () => {
        const items = [
            {
                label: 'First Name',
                value: _.get(this.props.recipient, 'firstName')
            },
            {
                label: 'Last Name',
                value: _.get(this.props.recipient, 'lastName')
            },
            {
                label: 'Email',
                value: _.get(this.props.recipient, 'email')
            },
            {
                label: 'Recipient ID',
                value: _.get(this.props.recipient, 'recipientId')
            },
            {
                label: 'Recipient Reference',
                value: _.get(this.props.recipient, 'recipientRef')
            },
            {
                label: 'Payout Provider ID',
                value: _.get(this.props.recipient, 'providerId')
            },
            {
                label: 'Payout Provider Type',
                value: _.upperCase(payoutProviderMapper[_.get(this.props.recipient, 'providerType')])
            },
            {
                label: 'Address Line 1',
                value: _.get(this.props.recipient, 'addressLine1')
            },
            {
                label: 'Address Line 2',
                value: _.get(this.props.recipient, 'addressLine2')
            },
            {
                label: 'City',
                value: _.get(this.props.recipient, 'city')
            },
            {
                label: 'State / Region',
                value: _.get(this.props.recipient, 'region')
            },
            {
                label: 'Postal Code',
                value: _.get(this.props.recipient, 'postalCode')
            },
            {
                label: 'Country',
                value: _.get(this.props.recipient, 'country')
            },
            {
                label: 'Phone Number',
                value: _.get(this.props.recipient, 'phoneNumber')
            },
            {
                label: 'Mobile Number',
                value: _.get(this.props.recipient, 'mobileNumber')
            },
            {
                label: 'Created Date',
                value: _.get(this.props.recipient, 'createdAt') && prettifyDate(_.get(this.props.recipient, 'createdAt'))
            },
            {
                label: 'Updated Date',
                value: _.get(this.props.recipient, 'updatedAt') && prettifyDate(_.get(this.props.recipient, 'updatedAt'))
            }
        ];

        return this.renderCard(items, 'Recipient Details');
    };

    renderCard(items, headerTitle) {
        if (items.some((item) => (item.value))) {
            return (
                <EmvioCard className="half-width grow-height" HeaderComponent={headerTitle}>
                    {items.map((item) =>
                        <EmvioTwoColumnItem
                            key={item.label || item.value}
                            alterMethod={item.alterMethod}
                            label={item.label}
                            value={item.value}
                            breakAll={item.breakAll}
                        />
                    )}
                </EmvioCard>);
        } else {
            return null;
        }
    }

    render() {
        if (this.props.isRecipientLoading) {
            return (<EmvioLoadingSpinner />);
        } else if (this.props.recipient && this.props.payoutAccountMap && !this.props.error) {
            return (
                <div className="emvio-payout-recipient">
                    <EmvioRow>
                        {this.renderDetails()}
                        {this.renderPayoutSummary()}
                    </EmvioRow>
                    <Payouts
                        isForPayoutRecipientTable={true}
                        recipientId={this.props.recipient.recipientId}
                        uniqueTableName="recipientPayouts"
                    />
                </div>
            );
        } else {
            return (
                <div className="emvio-payout-recipient">
                    <EmvioRow>
                        <ErrorCard />
                    </EmvioRow>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        error: getRecipientErrorMessage(state),
        isRecipientLoading: getIsRecipientLoading(state),
        recipient: getRecipient(state),
        payoutAccountMap: getPayoutAccountsMapper(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetRecipientById: (recipientId) => dispatch(getPayoutRecipient(recipientId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Recipient));
